

<template>
    <div class="mobileTeam h100">
      <mobileHeader></mobileHeader>
      <div class="page page-4">
        <div class="page4Warp flexB w100 h100">
          <div class="zwHeader w100"></div>
          <div class="content flex1 w100">
            <div class="title fb fAb">Team</div>
            <div class="list w100">
              <div class="lInfo">
                <div class="lName fb fOH">{{ teamInfo.nickname }}</div>
                <div class="lDesc fOR">{{ teamInfo.zw_name }}</div>
                <img class="lInfoImage" @click="goBack" src="../../assets/image/team-bak.png" alt="">
              </div>
              <div class="lDesc fOb" style="padding-top: 1rem" v-html="teamInfo.desc">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>
<script>

import TeamView from "@/components/Team/mobile.vue";
import mobileHeader from "@/components/Common/MobileHeader.vue";

export default {
  components: {mobileHeader, TeamView},

  computed: {
    teamInfo(){
      return this.$store.getters.teamInfo
    }
  },
  methods:{
    goBack(){
     this.$emit('goBack')
    }
  }
}
</script>
<style scoped lang="scss">
.page-4{
  height: 100%;
  background-image: url("../../assets/image/mobile/m_bg_4.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  .page4Warp{
    margin: auto;
    padding: 1.3rem;
    box-sizing: border-box;
    padding-bottom: 0;
    .content{
      color: #fff;
      display: flex;
      align-items: center;
      flex-direction: column;
      overflow: hidden;
      .title{
        font-size: 1.5rem;
        padding-bottom: 1rem;
      }
      .list{
        box-sizing: border-box;
        overflow: hidden;
        overflow-y: auto;
        max-height: 85%;
        background: linear-gradient(-20deg, #185FCB 0%, #74B5D4 100%);
        border-radius: 20px;
        opacity: 0.95;
        padding: 1.3rem 1.3rem;
        margin: 0 1.3rem;
        display: flex;
        justify-content: flex-start;
        flex-direction: column;
        .lDesc{
          flex: 1;
          overflow: hidden;
          overflow-y: auto;
          font-size: .9rem;
          //padding-top: .3rem;
          line-height: 1.5rem;
        }
        .lInfo{
          padding-bottom: 1rem;
          border-bottom: .05rem solid rgba(255,255,255,.8);
          position: relative;
          .lInfoImage{
            position: absolute;
            right: 0;
            top: 0;
            z-index: 10;
            width: 1rem;
          }
          .lName{
            font-size: 1.3rem;
          }
          .lDesc{
            font-size: .9rem;
            margin-top: .3rem;
          }
        }
      }
    }
  }
}
</style>
